import { ICreativeDimensionBoards, LayoutDimension } from '@/common/interfaces';
import { CanvasTypes } from '@/views/creatives/enums';
import { CreativeData } from '@/views/creatives/interfaces';

export const DATA_BLANK = {
  assets: {},
  frames: [],
  boards: [],
  instances: {},
  iterations: {},
  variations: {},
};

export const DATA_BACKGROUND = {
  frames: [{
    id: 'F_Back',
    name: 'Background',
    type: CanvasTypes.BACKGROUND,
  }],
  instances: {
    F_Back: [
      {
        id: 'I_vJmwe',
        name: 'Background Instance 1',
        hidden: false,
        locked: [],
      },
    ],
  },
  iterations: {
    F_Back: {
      M_1: {
        color: '#000000',
      },
      M_2: {
        color: '#000000',
      },
      M_3: {
        color: '#000000',
      },
    },
  },
  variations: {},
};

export const DATA_ASSET_IMAGE_A = {
  id: 'I_IMAGE1',
  name: 'Asset Image',
  src: 'assets/icons8-jake-150.png',
};

export const DATA_ASSET_IMAGE_B = {
  id: 'I_IMAGE2',
  name: 'Asset Image',
  src: 'assets/icons8-jake-150.png',
};

export const DATA_BACKGROUND_IMAGE_A = {
  id: 'I_BK1',
  name: 'Asset Image',
  src: 'assets/icons8-jake-150.png',
};

export const DATA_BACKGROUND_IMAGE_B = {
  id: 'I_BK2',
  name: 'Asset Image',
  src: 'assets/icons8-jake-150.png',
};

export const DATA_BACKGROUND_IMAGE_C = {
  id: 'I_BK3',
  name: 'Asset Image',
  src: 'assets/icons8-jake-150.png',
};

export const DATA_BASIC: CreativeData = {
  ...DATA_BLANK,
  assets: {
    I_IMAGE1: DATA_ASSET_IMAGE_A,
    I_IMAGE2: DATA_ASSET_IMAGE_B,
    I_BK1: DATA_BACKGROUND_IMAGE_A,
    I_BK2: DATA_BACKGROUND_IMAGE_B,
    I_BK3: DATA_BACKGROUND_IMAGE_C,
  },
  boards: [],
  frames: [
    {
      id: 'F_ImaGe',
      name: 'Featured Image',
      type: CanvasTypes.IMAGE,
      locked: [],
      hidden: false,
    },
    {
      id: 'F_TexT',
      name: 'Texts',
      type: CanvasTypes.TEXT,
      locked: [],
      hidden: false,
    },
    {
      id: 'F_Back',
      name: 'Backgrounds',
      type: CanvasTypes.BACKGROUND,
      hidden: false,
    },
  ],
  instances: {
    F_Back: [
      {
        id: 'I_vJmwe',
        name: 'Background Instance A',
        assetId: DATA_BACKGROUND_IMAGE_A.id,
        hidden: false,
      },
      {
        id: 'I_TEST2',
        name: 'Background Inst B',
        assetId: DATA_BACKGROUND_IMAGE_B.id,
        hidden: false,
      },
      {
        id: 'I_TEST3',
        name: 'Background Inst C',
        assetId: DATA_BACKGROUND_IMAGE_C.id,
        hidden: false,
      },
    ],
    F_ImaGe: [
      {
        id: 'I_Jmeow',
        name: 'Image Inst A',
        assetId: DATA_ASSET_IMAGE_A.id,
        hidden: false,
      },
      {
        id: 'I_vJnra',
        name: 'Image Inst B',
        assetId: DATA_ASSET_IMAGE_B.id,
        hidden: false,
      },
    ],
    F_TexT: [
      {
        id: 'T_txt01',
        name: 'Text Instance A',
        text: 'Text Data A',
        hidden: false,
      },
      {
        id: 'T_txt02',
        name: 'Text Instance B',
        text: 'Text Sample!',
        hidden: false,
      },
    ],
  },
  iterations: {
    F_Back: {
      M_3: {
        color: '#000000',
      },
    },
  },
  variations: {},
};

export const DATA_DEMO: CreativeData = {
  ...DATA_BLANK,
  assets: {
    I_Main1: {
      id: 'I_Main1',
      name: 'I_Main1',
      src: 'https://s3-us-west-1.amazonaws.com/craftsman-prod/1618512563060-1618512563060.tmp',
    },
    I_Main2: {
      id: 'I_Main2',
      name: 'I_Main2',
      src: 'https://s3-us-west-1.amazonaws.com/craftsman-prod/1618517928024-1618517928024.tmp',
    },
    I_Left1: {
      id: 'I_Left1',
      name: 'I_Left1',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615477647896-1615477647896.tmp',
    },
    I_Left2: {
      id: 'I_Left2',
      name: 'I_Left2',
      src: 'https://s3-us-west-1.amazonaws.com/craftsman-prod/1623967003593-1623967003593.tmp',
    },
    I_Right1: {
      id: 'I_Right1',
      name: 'I_Right1',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615477702259-1615477702259.tmp',
    },
    I_Right2: {
      id: 'I_Right2',
      name: 'I_Right2',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615532295028-1615532295028.tmp',
    },
    I_AppIcon1: {
      id: 'I_AppIcon1',
      name: 'Asset I_AppIcon1',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615477542675-1615477542675.tmp',
    },
    I_AppIcon2: {
      id: 'I_AppIcon2',
      name: 'Asset I_AppIcon2',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615477596109-1615477596109.tmp',
    },
    I_PhoneFrame: {
      id: 'I_PhoneFrame',
      name: 'Asset I_PhoneFrame',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615477315049-1615477315049.tmp',
    },
    I_CTATextImg: {
      id: 'I_CTATextImg',
      name: 'Asset I_CTATextImg',
      src: 'https://s3-us-west-1.amazonaws.com/cdn-craftsman/1615477764145-1615477764145.tmp',
    },
  },
  frames: [
    {
      id: 'F_T_MainCopy',
      name: 'Main Copy',
      type: CanvasTypes.TEXT,
      locked: [],
    },
    {
      id: 'F_I_PhoneFrame',
      name: 'Phone Frame',
      type: CanvasTypes.IMAGE,
      locked: [],
    },
    {
      id: 'F_I_CenterImage',
      name: 'Center Image',
      type: CanvasTypes.IMAGE,
      locked: [],
    },
    {
      id: 'F_I_AppIcon',
      name: 'App Icon',
      type: CanvasTypes.IMAGE,
      locked: [],
    },
    {
      id: 'F_I_LeftImage',
      name: 'Left Image',
      type: CanvasTypes.IMAGE,
      locked: [],
    },
    {
      id: 'F_I_RightImage',
      name: 'Right Image',
      type: CanvasTypes.IMAGE,
      locked: [],
    },
    {
      id: 'F_T_CTAText',
      name: 'CTA Text',
      type: CanvasTypes.TEXT,
      locked: [],
    },
    {
      id: 'F_Back',
      name: 'Backgrounds',
      type: CanvasTypes.BACKGROUND,
    },
  ],
  boards: [],
  instances: {
    F_T_MainCopy: [
      {
        id: 'T_MainCopy1',
        name: 'Main Text 1',
        text: 'Main Text 1 is the first text element, where the text wraps.',
      },
      {
        id: 'T_MainCopy2',
        name: 'Main Text 2',
        text: 'Main Text 2',
      },
    ],
    F_I_CenterImage: [
      {
        id: 'I_Main1',
        name: 'Main 1',
        assetId: 'I_Main1',
      },
      {
        id: 'I_Main2',
        name: 'Main 2',
        assetId: 'I_Main2',
      },
    ],
    F_I_AppIcon: [
      {
        id: 'I_AppIcon1',
        name: 'Icon 1',
        assetId: 'I_AppIcon1',
      },
      {
        id: 'I_AppIcon2',
        name: 'Icon 2',
        assetId: 'I_AppIcon2',
      },
    ],
    F_I_LeftImage: [
      {
        id: 'I_Left1',
        name: 'Left 1',
        assetId: 'I_Left1',
      },
      {
        id: 'I_Left2',
        name: 'Left 2',
        assetId: 'I_Left2',
      },
    ],
    F_I_RightImage: [
      {
        id: 'I_Right1',
        name: 'Right 1',
        assetId: 'I_Right1',
      },
      {
        id: 'I_Right2',
        name: 'Right 2',
        assetId: 'I_Right2',
      },
    ],
    F_I_PhoneFrame: [
      {
        id: 'I_PhoneFrame',
        name: 'Phone Frame',
        assetId: 'I_PhoneFrame',
      },
    ],
    F_T_CTAText: [
      {
        id: 'T_CTAtxt01',
        name: 'CTA Text 1',
        text: 'CTA 1',
      },
      {
        id: 'T_CTAtxt02',
        name: 'CTA Text 2',
        text: 'CTA 2',
      },
    ],
    F_Back: [
      {
        id: 'I_vJmwe',
        name: 'Main Background Instance',
      },
    ],
  },
  iterations: {
    F_T_MainCopy: {
      M_1: {
        x: 0.5,
        y: 0.2,
        w: 1,
        h: 0.25,
        shadow: {
          color: '#000000',
          alpha: 0.5,
        },
        size: '28',
        align: 'center' as const,
        textBaseline: 'middle' as const,
      },
      M_2: {
        x: 0.5,
        y: 0.2,
        w: 1,
        h: 0.25,
      },
      M_3: {
        x: 0.5,
        y: 0.2,
        w: 1,
        h: 0.25,
      },
      T_MainCopy1: {
        M_2: {
          shadow: {
            color: '#000000',
            alpha: 0.5,
          },
          size: '28',
          align: 'center',
          textBaseline: 'middle',
        },
        M_3: {
          shadow: {
            color: '#000000',
            alpha: 0.5,
          },
          size: '28',
          align: 'center',
          textBaseline: 'middle',
        },
      },
      T_MainCopy2: {
        M_1: {
          url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
          size: '28',
          align: 'center',
          alpha: 0.5,
          color: '#fff',
          style: 'normal',
          family: 'PermanentMarker-x99j',
          textBaseline: 'middle',
        },
        M_2: {
          url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
          size: '28',
          align: 'center',
          alpha: 0.5,
          color: '#fff',
          style: 'normal',
          family: 'PermanentMarker-x99j',
          textBaseline: 'middle',
        },
        M_3: {
          url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
          size: '28',
          align: 'center',
          alpha: 0.5,
          color: '#fff',
          style: 'normal',
          family: 'PermanentMarker-x99j',
          textBaseline: 'middle',
        },
      },
    },
    F_I_CenterImage: {
      M_1: {
        x: 0.5,
        y: 0.5,
        w: 0.5,
        h: 0.5,
        r: 45,
      },
      M_2: {
        x: 0.2,
        y: 0.5,
        w: 0.2,
        h: 0.5,
        aspectLock: false,
      },
      M_3: {
        x: 0.5,
        y: 0.5,
        w: 0.5,
        h: 0.5,
      },
      I_Main1: {
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 0.5625,
          h: 0.5,
          r: -45,
        },
        M_2: {
          x: 0.2,
          y: 0.5,
          w: 0.2,
          h: 0.5,
          aspectLock: false,
        },
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.49999999999999994,
          h: 0.6666666666666665,
        },
      },
      I_Main2: {
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.75,
          h: 1,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 1.125,
          h: 1,
        },
        M_2: {
          x: 0.5,
          y: 0.5,
          w: 0.75,
          h: 1.5,
        },
      },
    },
    F_I_AppIcon: {
      M_1: {
        x: 0.5,
        y: 0.8,
        w: 0.1,
        h: 0.15,
      },
      M_2: {
        x: 0.75,
        y: 0.5,
        w: 0.15,
        h: 0.225,
        aspectLock: false,
      },
      M_3: {
        x: 0.5,
        y: 0.8,
        w: 0.1,
        h: 0.15,
      },
      I_AppIcon1: {
        M_2: {
          aspectLock: false,
          x: 0.75,
          w: 0.15,
          h: 0.225,
        },
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.15,
          h: 0.15,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 0.225,
          h: 0.15,
        },
      },
      I_AppIcon2: {
        M_2: {
          x: 0.75,
          y: 0.5,
          w: 0.15,
          h: 0.07580213903743316,
        },
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 1,
          h: 0.3368983957219251,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 1.5,
          h: 0.33689839572192515,
        },
      },
    },
    F_I_LeftImage: {
      M_1: {
        x: 0.25,
        y: 0.5,
        w: 0.4,
        h: 0.4,
      },
      M_2: {
        x: 0.35865762892078673,
        y: 0.5,
        w: 0.18,
        h: 0.45,
        aspectLock: true,
      },
      M_3: {
        x: 0.25,
        y: 0.5,
        w: 0.4,
        h: 0.4,
      },
      I_Left1: {
        M_2: {
          w: 0.4029754204398448,
          h: 0.75,
          x: 0.35865762892078673,
          y: 0.5,
        },
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.4,
          h: 0.4963081861958266,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 0.48357050452781375,
          h: 0.4,
        },
      },
      I_Left2: {
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.75,
          h: 1,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 1.125,
          h: 1,
        },
        M_2: {
          x: 0.5,
          y: 0.5,
          w: 0.75,
          h: 1.5,
        },
      },
    },
    F_I_RightImage: {
      M_1: {
        x: 0.75,
        y: 0.5,
        w: 0.4,
        h: 0.4,
      },
      M_2: {
        x: 0.5,
        y: 0.5,
        w: 0.15,
        h: 0.375,
        aspectLock: true,
      },
      M_3: {
        x: 0.75,
        y: 0.5,
        w: 0.4,
        h: 0.4,
      },
      I_Right1: {
        M_2: {
          w: 0.2,
          h: 0.375,
          aspectLock: false,
        },
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.4,
          h: 0.5,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 0.48,
          h: 0.4,
        },
      },
      I_Right2: {
        M_3: {
          x: 0.75,
          y: 0.5,
          w: 0.26027397260273977,
          h: 0.4,
        },
        M_2: {
          w: 0.15,
          h: 0.375,
          aspectLock: false,
        },
        M_1: {
          x: 0.5,
          y: 0.5,
          w: 0.9760273972602741,
          h: 1,
        },
      },
    },
    F_I_PhoneFrame: {
      M_1: {
        x: 0.5,
        y: 0.5,
        w: 0.5,
        h: 0.5,
      },
      M_2: {
        x: 0.2,
        y: 0.5,
        w: 0.2,
        h: 0.5,
        aspectLock: false,
      },
      M_3: {
        x: 0.5,
        y: 0.5,
        w: 0.5,
        h: 0.5,
      },
      I_PhoneFrame: {
        M_1: {
          x: 0.49912280701754386,
          y: 0.49912280701754386,
          w: 0.5160401002506267,
          h: 0.5160401002506267,
        },
        M_2: {
          x: 0.2,
          y: 0.5005215419501133,
          w: 0.2,
          h: 0.5011791383219957,
          aspectLock: false,
        },
        M_3: {
          x: 0.5,
          y: 0.5,
          w: 0.5,
          h: 1.034521158129176,
        },
      },
    },
    F_T_CTAText: {
      M_1: {
        x: 0.5,
        y: 0.8,
        w: 1,
        h: 0.25,
      },
      M_2: {
        x: 0.858173076923077,
        y: 0.7682291666666665,
        w: 0.18365384615384633,
        h: 0.1010416666666667,
        aspectLock: false,
      },
      M_3: {
        x: 0.5,
        y: 0.8,
        w: 1,
        h: 0.25,
      },
      T_CTAtxt01: {
        M_1: {
          shadow: {
            color: '#000000',
            alpha: 0.5,
          },
          size: '18',
          align: 'center',
          textBaseline: 'middle',
        },
        M_2: {
          shadow: {
            color: '#000000',
            alpha: 0.5,
          },
          size: '18',
          align: 'center',
          textBaseline: 'middle',
        },
        M_3: {
          shadow: {
            color: '#000000',
            alpha: 0.5,
          },
          size: '18',
          align: 'center',
          textBaseline: 'middle',
        },
      },
      T_CTAtxt02: {
        M_1: {
          url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
          size: '18',
          align: 'center',
          alpha: 1,
          family: 'PermanentMarker-x99j',
          textBaseline: 'middle',
        },
        M_2: {
          url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
          size: '18',
          align: 'center',
          alpha: 1,
          family: 'PermanentMarker-x99j',
          textBaseline: 'middle',
        },
        M_3: {
          url: 'https://s3.amazonaws.com/production-elasticbeanstalk-environmen-databucket-1v9icak6ecq6y/1646283520645-1646283520645.tmp',
          size: '18',
          align: 'center',
          alpha: 1,
          family: 'PermanentMarker-x99j',
          textBaseline: 'middle',
        },
      },
    },
    F_Back: {
      I_vJmwe: {
        M_1: {
          color: '#098939',
        },
        M_2: {
          color: '#0Ba9a9',
        },
        M_3: {
          color: '#aB59a9',
        },
      },
    },
  },
  variations: {},
};

// From API
export const CUSTOM_DIMENSIONS : ICreativeDimensionBoards[] = [{
  id: 1,
  masterId: 3,
  name: '100x100',
  width: 100,
  height: 100,
  isEnabled: true,
}, {
  id: 2,
  masterId: 3,
  name: '200x200',
  width: 200,
  height: 200,
  isEnabled: true,
}, {
  id: 3,
  masterId: 3,
  name: '300x300',
  width: 300,
  height: 300,
  isEnabled: true,
}];

// What we store on canvasStore
export const CANVAS_CUSTOM_DIMENSIONS : LayoutDimension[] = [{
  id: 'C_1',
  masterId: 'M_3',
  name: '100x100',
  width: 100,
  height: 100,
  isEnabled: true,
}, {
  id: 'C_2',
  masterId: 'M_3',
  name: '200x200',
  width: 200,
  height: 200,
  isEnabled: true,
}, {
  id: 'C_3',
  masterId: 'M_3',
  name: '300x300',
  width: 300,
  height: 300,
  isEnabled: true,
}];

export const DEFAULT_CUSTOM_DIMENSIONS = {
  id: 4,
  masterId: 3,
  name: '100x100',
  width: 100,
  height: 100,
  isEnabled: true,
};
